export { default } from './consultBanner';
